/* NewDashboardLayout.tsx */
import React from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { Link as RouterLink, Outlet } from 'react-router-dom';

import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import PaymentIcon from '@mui/icons-material/Payment';
import SettingsIcon from '@mui/icons-material/Settings';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

import Header from 'components/Header';
import styles from './styles';

const menuItems = [
  { text: 'Visão Geral', icon: <HomeIcon />, path: '/dashboard' },
  { text: 'Perfil', icon: <PersonIcon />, path: '/dashboard/profile' },
  {
    text: 'Minhas Assinaturas',
    icon: <SubscriptionsIcon />,
    path: '/dashboard/subscription',
  },
  {
    text: 'Meus Pedidos',
    icon: <PaymentIcon />,
    path: '/dashboard/orders',
  },
  {
    text: 'Suporte',
    icon: <SupportAgentIcon />,
    path: '/dashboard/support',
  },
  {
    text: 'Configurações',
    icon: <SettingsIcon />,
    path: '/dashboard/settings',
  },
];

const NewDashboardLayout: React.FC = () => {
  return (
    <Box sx={styles.root}>
      <AppBar position="fixed" sx={styles.appBar}>
        <Header />
      </AppBar>

      <Drawer variant="permanent" anchor="left" sx={styles.drawer}>
        <Toolbar />
        <List>
          {menuItems.map(({ text, icon, path }) => (
            <ListItem
              key={text}
              component={RouterLink}
              to={path}
              disablePadding
            >
              <ListItemButton>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>

      <Box component="main" sx={styles.main}>
        {/* <Toolbar /> */}
        <Outlet />
      </Box>
    </Box>
  );
};

export default NewDashboardLayout;
